import { Section } from '../UI/IgmtInk'

const RSVP = props => {
  return (
    <Section className="px-4 py-9 grid grid-cols-1 gap-6 lg:gap-8 justify-items-center bg-[#f9f9f9]">
      <p className="text-center sm:text-lg sm:max-w-md md:text-xl md:max-w-xl lg:text-2xl">
        Please let us know if you will be able to join us for this special
        occasion by clicking the RSVP button below. We can't wait to celebrate
        with you!
      </p>
      <a
        className="bg-blue-500 hover:bg-blue-600 transition-colors px-6 py-3 rounded-md font-bold shadow-lg"
        href="https://forms.gle/rgNAofXbFoabEk7c7"
      >
        RSVP NOW!
      </a>
    </Section>
  )
}

export default RSVP
